// src/pages/VerificationPage.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

// CSS
import "./VerificationPage.css";

// Components
import PageLoader from "../../Components/Other Components/pageLoader";
import Button from "../../Components/Other Components/button";
import Title from "../../Components/Other Components/Title";

// Functions and hooks
import { ResendRegisterEmail } from "../../BackendAccess/UserHooks";
import { fetchWithTimeout } from "../../hooks/useFetchWithTimeout";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useNotification } from "../../Contexts/NotificationContext";

export default function VerificationPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);

  useEffect(() => {
    // no setup needed for this page
  }, []);

  const onResendClick = async () => {
    try {
      showNotification(t("verificationSent.info.sending"), "info");
      const [data, err] = await fetchWithTimeout(() =>
        ResendRegisterEmail(email)
      );
      if (err) {
        setError(err);
      } else {
        showNotification(t("verificationSent.success.sent"), "success");
      }
    } catch {
      setError({ err: t("verificationSent.error.server"), errCode: 500 });
    }
  };

  const onLoginClick = () => navigate("/login");

  return (
    <PageWrapper>
      <PageLoader loading={loading} error={pageError}>
        <div className="page-content">
          <div className="container-bordered verification-container mt-3">
            <Title>{t("verificationSent.title")}</Title>
            <span className="verification-text">
              {t("verificationSent.message.sentTo", { email })}
            </span>
            <span className="verification-text font-bold">
              {t("verificationSent.message.checkEmail")}
            </span>
            <span className="verification-text">
              {t("verificationSent.message.notFound")}
            </span>
            <div className="btn-container mt-3 w-100">
              <Button onClick={onResendClick}>
                {t("verificationSent.button.resend")}
              </Button>
              <Button onClick={onLoginClick}>
                {t("verificationSent.button.login")}
              </Button>
            </div>
          </div>
        </div>
      </PageLoader>
    </PageWrapper>
  );
}
